import { useMemo } from 'react';
import { ContentLexicalStateV1 } from '@soundxyz/utils/lexical/ContentLexicalStateV1';
import { LexicalUtils } from '@components/Lexical/utils';

export function useLexicalValidate(lexicalContent: unknown) {
  const lexicalState = useMemo(() => {
    if (!lexicalContent) return null;
    const parsed = ContentLexicalStateV1.safeParse(lexicalContent);
    if (parsed.success) {
      return parsed.data;
    } else {
      return null;
    }
  }, [lexicalContent]);

  return lexicalState;
}

export function useLexicalValidateGetText(lexicalContent: unknown) {
  const lexicalState = useLexicalValidate(lexicalContent);
  const text = useMemo(() => {
    return LexicalUtils.generateTextForNode(lexicalState?.root);
  }, [lexicalState]);
  return text.length ? text : null;
}
